document.addEventListener("DOMContentLoaded", function (event) {
    ProductReviewSliderInit()
    TextWithIcons2SliderInit()
});
function ProductReviewSliderInit() {
    const sliders = document.querySelectorAll(".js-product-review");

    sliders.forEach(slider => {
        const productReviewBox = slider.querySelectorAll('.product-review-box');

        if (productReviewBox.length > 1 && !slider.classList.contains('tns-slider')) {
            tns({
                container: slider,
                loop: true,
                items: 1,
                slideBy: 1,
                autoplay: false,
                mouseDrag: true,
                navPosition: "bottom",
                disable: true,
                autoplayButtonOutput: false,
                lazyload: true,
                // center: true,
                gutter: 15,
                autoHeight: false,
                responsive: {
                    320: {
                        items: 1,
                        disable: false
                    },

                    1000: {
                        disable: true
                    }
                }
            });
        }
    });
}
function TextWithIcons2SliderInit() {
    const sliders = document.querySelectorAll(".js-text-with-icons-2");

    sliders.forEach(slider => {
        const TextWithIcons2Box = slider.querySelectorAll('.js-text-with-icons-2 .text-with-icons-2__item');

        if (TextWithIcons2Box.length > 1 && !slider.classList.contains('tns-slider')) {
            tns({
                container: slider,
                loop: true,
                nav: false,
                controls: false,
                items: 1,
                slideBy: 1,
                autoplay: true,
                autoplayTimeout: 3500,
                autoplayButtonOutput: false,
                mouseDrag: true,
                disable: true,
                lazyload: true,
                // center: true,
                edgePadding: 60,
                autoHeight: false,
                responsive: {
                    320: {
                        items: 1,
                        disable: false
                    },

                    641: {
                        disable: true
                    }
                }
            });
        }
    });
}

/* FAQ 3 */

class ComponentFaq3 extends HTMLElement {
    constructor() {
        super();
        this.collapsibleObjects = this.querySelectorAll('o-collapsible-1');
        this.closeInactiveItems = this.closeInactiveItems.bind(this);
        this.toggleFaqList = this.toggleFaqList.bind(this);
    }

    connectedCallback() {
        this.addEventListener('collapsibleOpened', (e) => this.closeInactiveItems(e.detail));

        // Add delegated click event
        this.addEventListener('click', (event) => {
            const headerIcon = event.target.closest('.c-faq-3__header-icon');
            if (headerIcon) {
                this.toggleFaqList();
            }
        });
    }

    closeInactiveItems(activeItem) {
        this.collapsibleObjects.forEach((elem) => {
            if (elem !== activeItem) {
                elem.closeContent();
            }
        });
    }

    toggleFaqList() {
        if (this.faqList.classList.contains('active')) {
            this.faqList.classList.remove('active');
        } else {
            this.faqList.classList.add('active');
        }
    }
}

customElements.define('c-faq-3', ComponentFaq3);

class ObjectCollapsible1 extends HTMLElement {
    constructor() {
        super();
        this.openContent = this.openContent.bind(this);
        this.closeContent = this.closeContent.bind(this);
        this.toggleContent = this.toggleContent.bind(this);
    }

    connectedCallback() {
        const trigger = this.querySelector('.js-collapsible-trigger');
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleContent();
        });
    }

    openContent() {
        this.classList.add('is-opened');
        this.querySelector('.js-collapsible-content').style.display = 'block';
        this.dispatchEvent(new CustomEvent('collapsibleOpened', {detail: this}));
    }

    closeContent() {
        this.classList.remove('is-opened');
        this.querySelector('.js-collapsible-content').style.display = 'none';
        this.dispatchEvent(new CustomEvent('collapsibleClosed', {detail: this}));
    }

    toggleContent() {
        if (this.classList.contains('is-opened')) {
            this.closeContent();
        } else {
            this.openContent();
        }
    }

    isContentOpened() {
        return this.classList.contains('is-opened');
    }
}

customElements.define('o-collapsible-1', ObjectCollapsible1);


/* END FAQ 3 */
function scrollToDeliverySchedule(element) {
    const targetElement = element.closest('.section--featured-product-3').querySelector('.js-delivery-schedule');

    const isInViewport = function (element) {
        const rect = element.getBoundingClientRect();
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
        );
    };

    if (targetElement) {
        if (!isInViewport(targetElement)) {
            targetElement.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }
}
